<template>
  <div>
    <!-- 筛选 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">选手信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="100px"
        ref="queryFormRef"
      >
        <el-row :gutter="0">
          <el-col :span="6">
            <el-form-item label="赛季" prop="season">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.season"
                clearable
                @change="seasonHandleChange"
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="赛区" prop="districtId">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.districtId"
              >
                <el-option
                  v-for="item in dict_district"
                  :key="item.id"
                  :label="item.districtName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="赛程" prop="raceSchedule">
              <el-select
                placeholder="请选择"
                @visible-change="changeRaceScheduleValue"
                style="width: 100%"
                v-model="queryForm.raceSchedule"
                clearable
              >
                <el-option
                  v-for="item in raceScheduleList"
                  :key="item.id"
                  :label="item.scheduleName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="6">
            <el-form-item label="学校省市区" prop="schoolArea">
              <el-cascader
                placeholder="请选择"
                v-model="queryForm.schoolArea"
                ref="schoolAreaRef"
                :options="areasData"
                style="width: 100%"
                :props="{
                  expandTrigger: 'hover',
                  label: 'name',
                  value: 'areaId',
                  children: 'areas',
                }"
                @change="provincesHandleChange"
              ></el-cascader>
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <el-form-item label="组别" prop="enrollmentLevel">
              <el-select
                style="width: 100%"
                placeholder="请选择"
                v-model="queryForm.enrollmentLevel"
                clearable
              >
                <el-option
                  v-for="item in dict_group"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="学校" prop="schoolId">
              <!-- <el-select
                style="width: 100%"
                placeholder="请选择"
                v-model="queryForm.schoolId"
                @change="schoolSelectChange"
                clearable
              >
                <el-option
                  v-for="item in provincesSchoolList"
                  :key="item.id"
                  :label="item.schoolName"
                  :value="item.id"
                ></el-option>
              </el-select> -->
              <el-select
                v-model="queryForm.schoolId"
                filterable
                remote
                style="width: 100%;"
                reserve-keyword
                placeholder="请输入关键词"
                :remote-method="remoteMethod"
                :loading="loading">
                <el-option
                  v-for="item in schools"
                  :key="item.id"
                  :label="item.schoolName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="姓名" prop="userName">
              <el-input
                v-model="queryForm.userName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="queryForm.phone"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="是否晋级" prop="promotion">
              <el-select
                style="width: 100%"
                placeholder="请选择"
                v-model="queryForm.promotion"
                clearable
              >
                <el-option label="晋级" value="1"></el-option>
                <el-option label="未晋级" value="2"></el-option>
                <el-option label="未设置" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="开通类型" prop="openType">
              <el-select
                style="width: 100%"
                placeholder="请选择"
                v-model="queryForm.openType"
                clearable
              >
                <el-option
                  v-for="item in p_open_type"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="参赛方式" prop="isOnline">
              <el-select
                style="width: 100%"
                placeholder="请选择"
                v-model="queryForm.isOnline"
                clearable
              >
                <el-option v-for="opt of match_type" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
                <!-- <el-option label="线上" :value="1"></el-option> -->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="订单号" prop="orderNo">
              <el-input
                v-model="queryForm.orderNo"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" align="right">
            <el-button
              type="primary"
              @click="getDataList('search')"
              >查询</el-button
            >
            <el-button type="primary" plain @click="reset"
              >重置</el-button
            >
          </el-col>
        </el-row>
      </el-form>
      <!-- <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button
            type="primary"
            style="width: 100%"
            @click="getDataList('search')"
            >查询</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button type="primary" plain style="width: 100%" @click="reset"
            >重置</el-button
          >
        </el-col>
      </el-row> -->
    </el-card>
    <!-- 报名信息列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="12">
          <span class="title_class">选手信息列表({{ total }}人)</span>
        </el-col>
        <el-col :span="12" style="text-align: right;">
          <el-button
            type="primary"
            plain
            icon="el-icon-download"
            @click="exportTable()"
            >批量导出</el-button
          >
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="赛季" prop="season"></el-table-column>
        <el-table-column label="赛区" prop="districtName"></el-table-column>
        <el-table-column label="姓名" prop="userName">
          <template slot-scope="scope">
            <el-link style="color: #409EFF;" @click="handleToUserDetails(scope.row.userId)">{{ scope.row.userName }}</el-link>
          </template>
        </el-table-column>
        <!-- <el-table-column label="选手照片" prop="userpicurl">
          <template slot-scope="scope">
            <el-image
              style="width: 50px; height: 50px"
              :src="scope.row.userpicurl ? scope.row.userpicurl : 'https://cdn.spbcn.org/spbcnapp/userpic/yonghu_defult.png'"
              :preview-src-list="[scope.row.userpicurl]"
            >
            </el-image>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          label="性别"
          prop="gender"
          :formatter="genderFormatter"
        ></el-table-column> -->
        <!-- <el-table-column label="省市区" prop="provence">
           <template slot-scope="scope">
            <span>{{scope.row.provinceName}}/{{scope.row.cityName}}/{{scope.row.countyName}}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="学校" prop="schoolName">
          <template slot-scope="scope">
            <span
              v-if="scope.row.fillschoolName && scope.row.fillschoolName !== ''"
              >{{ scope.row.fillschoolName }}</span
            >
            <span v-else>{{ scope.row.schoolName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="组别"
          prop="enrollmentLevel"
          :formatter="groupFormatter"
        ></el-table-column>
        <el-table-column
          label="年级"
          prop="grade"
          :formatter="gradeFormatter"
        ></el-table-column>
        <!-- <el-table-column
          label="是否答题"
          prop="score"
        >
        <template slot-scope="scope">
            <el-tag
              type="success"
              v-if="scope.row.score"
              size="mini"
              >已答题</el-tag
            >
            <el-tag type="danger" v-else size="mini">未答题</el-tag>
          </template>
         </el-table-column> -->
         <!-- 是否晋级 2 未晋级 1 晋级 0 未设置 -->
        <el-table-column label="是否晋级" prop="promotion">
          <template slot-scope="scope">
            <el-tag :type="scope.row.promotion === 1 ? 'success' : scope.row.promotion === 2 ? 'danger' : 'info'" size="mini">
              {{ scope.row.promotion === 1 ? '晋级' : scope.row.promotion === 2 ? '未晋级' : '未设置' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="联系方式" prop="phone"></el-table-column>
        <el-table-column
          label="开通产品名称"
          prop="productName"
        ></el-table-column>
        <el-table-column
          label="开通类型"
          prop="openType"
          :formatter="openTypeFormatter"
          width="100px"
        ></el-table-column>
        <el-table-column label="参赛方式" prop="isOnline" width="125px">
          <template slot-scope="scope">
            <el-tag
              :type=" scope.row.score !== undefined ? 'success' : 'danger' "
              v-if="scope.row.isOnline + '' === '1'"
              size="mini"
              >线上参赛({{ scope.row.score !== undefined ? '已答题' : '未答题' }})</el-tag
            >
            <el-tag type="warning" v-else size="mini">线下参赛</el-tag>
            <!-- <span style="color: red" v-if="scope.row.isOnline === 1"
              >线上参赛</span
            >
            <span v-else style="color: green">线下参赛</span> -->
          </template>
        </el-table-column>
        <el-table-column label="报名时间" prop="createTime"></el-table-column>
        <el-table-column label="订单号" prop="orderNo"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="showEditDialog(scope.row)"
              >设置国赛晋级</el-button
            >
            <el-button
              v-if="raceSchedule !== '4'"
              type="text"
              icon="el-icon-edit"
              size="small"
              @click="showDialog(scope.row)"
              >修改</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <el-dialog title="修改参赛资格信息" :visible.sync="visible"
      width="30%"
      @close="handleCloseDialog">
      <el-form
          :model="editForm"
          label-width="80px"
          ref="editFormRef"
          :rules="editFormRules"
        >
        <el-row>
          <el-col :span="24">
            <el-form-item label="年级" prop="grade">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="editForm.grade"
              >
                <el-option
                  v-for="item in dict_grade"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictCode"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="组别" prop="enrollmentLevel">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="editForm.enrollmentLevel"
              >
                <el-option
                  v-for="item in dict_group"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictCode"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="参赛方式" prop="isOnline">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="editForm.isOnline"
              >
                <el-option
                  v-for="item in match_type"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" style="text-align: center; margin-top: 40px;">
            <el-button type="primary" @click="editFn">保存</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <!-- 修改线上成绩的dialog -->
    <el-dialog
      title="设置国赛晋级"
      :visible.sync="editScoreDialogVisible"
      @close="editScoreDialogClose"
      width="30%"
    >
      <el-form
        :model="editScoreForm"
        label-width="80px"
        ref="editScoreFormRef"
        :rules="editScoreFormRules"
      >
        <el-form-item label="姓名" prop="userName">
          <el-input
            v-model="editScoreForm.userName"
            placeholder="请输入"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="晋级资格" prop="promotion">
          <el-radio-group v-model="editScoreForm.promotion">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editScoreDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editScore">修 改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { queryTbEnrollmentList, getSchoolListWithCity, querySeasonRaceScheduleFlag, updateTbEnrollmentGroup, setTbEnrollmentPromotion, getAllAreaList } from '@/http/api'
export default {
  props: {
    promotion: {
      type: String,
      default: ''
    },
    level: {
      type: String
    },
    districtId: {
      type: String
    },
    raceSchedule: {
      type: String
    }
  },
  data () {
    return {
      timer: new Date().getTime(),
      getGradeData: this.$userInfo.getGradeData(),
      dict_group: this.$userInfo.dict_group(),
      p_open_type: this.$userInfo.getDataList(this, 'p_open_type').then(value => { this.p_open_type = value }),
      dict_season: this.$userInfo.getDataList(this, 't_season').then(value => { this.dict_season = value }),
      dict_district: [],
      queryForm: {
        phone: '',
        name: '',
        season: this.$chnEngStatusCode.defaultSeason,
        enrollmentLevel: '',
        schoolId: '',
        pageNum: 1,
        pageSize: 10,
        raceSchedule: '2',
        userName: '',
        isOnline: '',
        districtId: '',
        promotion: ''
      },
      raceScheduleList: [],
      total: 0,
      dict_grade: this.$userInfo.getGradeData(),
      dict_gender: this.$userInfo.getDataList(this, 't_gender').then(value => { this.dict_gender = value }),
      dataList: [],
      provincesSchoolList: [],
      areasData: [],
      match_type: [
        { label: '线下参赛', value: 0 },
        { label: '线上参赛', value: 1 }
      ], // 参赛方式
      editForm: {},
      visible: false,
      editFormRules: {
        enrollmentLevel: [{ required: true, message: '请选择组别', trigger: 'change' }],
        grade: [{ required: true, message: '请选择年级', trigger: 'change' }],
        isOnline: [{ required: true, message: '请选择参赛方式', trigger: 'change' }]
      },
      loading: false,
      schoolName: '',
      schools: [],
      editScoreForm: {
        activityType: this.$chnEngStatusCode.activityType,
        raceSchedule: null,
        season: this.$chnEngStatusCode.defaultSeason,
        userId: '',
        promotion: null
      },
      editScoreFormRules: {
        promotion: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      editScoreDialogVisible: false
    }
  },
  created () {
    // this.getDistrict()
    // this.getDataList()
    this.getAllAreaList()
  },
  methods: {
    // 获取省市区列表（接口）
    getAllAreaList () {
      getAllAreaList({}).then((res) => {
        if (res.code === 200) {
          this.areasData = res.data
        }
      }).catch((err) => {
        console.log('getAllAreaList err', err)
      })
    },

    remoteMethod (query) {
      console.log(query)
      this.schoolName = query
      if (query !== '') {
        this.loading = true
        this.getAllSchools()
      } else {
        this.schools = []
      }
    },
    getAllSchools () {
      this.$http.get('/school/getSysSchoolList', { params: { pageSize: 10000, pageNum: 1, schoolName: this.schoolName } }).then(res => {
        if (res.code === 200) {
          this.loading = false
          this.schools = res.data.list
        }
      })
    },
    getDistrict () {
      this.$http.get('/district/queryDistrictPage?pageNum=1&pageSize=10000').then(res => {
        if (res.code === 200) {
          this.dict_district = res.data.list
        }
      })
    },
    // 赛季选择事件回调
    seasonHandleChange (value) {
      var seasonStr = ''
      if (!value) {
        seasonStr = this.queryForm.season
      } else {
        seasonStr = value
      }
      var formData = {
        activityType: this.$chnEngStatusCode.activityType,
        season: seasonStr,
        scheduleFlag: this.$route.query.scheduleFlag
      }
      this.searchScheduleWithFlag(formData)
    },
    // 根据赛季标识符查询赛程相关
    searchScheduleWithFlag (formData) {
      querySeasonRaceScheduleFlag(formData).then((res) => {
        this.queryForm.raceSchedule = res.data.id
        this.getDataList('search')
      }).catch((err) => {
        console.log('err', err)
      })
    },
    searchFn () {
      this.queryForm.enrollmentLevel = this.level
      this.queryForm.districtId = this.districtId
      this.queryForm.promotion = this.promotion
      this.getDataList('search')
    },
    // 获取报名列表
    getDataList (getType) {
      if (getType === 'search') {
        this.queryForm.pageNum = 1
        this.queryForm.pageSize = 10
      }
      queryTbEnrollmentList(this.queryForm).then((res) => {
        console.log('queryTbEnrollmentList', res)
        this.dataList = res.data.list
        this.total = res.data.total
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 重置搜索条件
    reset () {
      this.$refs.queryFormRef.resetFields()
      this.schools = []
      this.getDataList()
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getDataList()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getDataList()
    },
    genderFormatter (data) {
      var temp = '未知'
      for (const key in this.dict_gender) {
        if (Object.hasOwnProperty.call(this.dict_gender, key)) {
          const element = this.dict_gender[key]
          if (element.dictValue === data.gender + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    gradeFormatter (data) {
      var temp = '未知'
      for (const key in this.dict_grade) {
        if (Object.hasOwnProperty.call(this.dict_grade, key)) {
          const element = this.dict_grade[key]
          if (element.dictValue === data.grade + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    openTypeFormatter (data) {
      var temp = '未知'
      for (const key in this.p_open_type) {
        if (Object.hasOwnProperty.call(this.p_open_type, key)) {
          const element = this.p_open_type[key]
          if (element.dictValue === data.openType + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    // 显示修改晋级弹窗
    showEditDialog (row) {
      console.log('row', row)
      this.editScoreForm.userName = row.userName
      this.editScoreForm.raceSchedule = row.raceSchedule
      this.editScoreForm.userId = row.userId ? row.userId : row.id
      this.editScoreForm.promotion = row.promotion
      this.editScoreDialogVisible = true
    },
    // 单个修改线上成绩
    editScore () {
      this.savePromotionInfoData(this.editScoreForm)
    },
    // 提交线上成绩
    async savePromotionInfoData (formData) {
      setTbEnrollmentPromotion(formData).then((res) => {
        this.editScoreDialogVisible = false
        this.$message.success('修改成功')
        this.getDataList(this.scoreTypeActiveName, 'search')
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    // 修改成绩弹窗关闭
    editScoreDialogClose () {
      this.$refs.editScoreFormRef.resetFields()
    },
    groupFormatter (data) {
      var temp = '未知'
      for (const key in this.dict_group) {
        if (Object.hasOwnProperty.call(this.dict_group, key)) {
          const element = this.dict_group[key]
          if (element.dictValue === data.enrollmentLevel + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    // 赛季选择事件回调
    // seasonHandleChange (value) {
    //   console.log('value', value)
    //   if (!value) return
    //   var formData = {
    //     activityType: this.$chnEngStatusCode.activityType,
    //     season: value
    //   }
    //   this.raceScheduleList = this.$chnEngPublicRequest.querySeasonRaceSchedule(this, formData).then(value => { this.raceScheduleList = value })
    // },
    // 赛程选择校验
    changeRaceScheduleValue (state) {
      console.log(state)
      if (state === true && this.queryForm.season === '') {
        this.$message.error('请先选择赛季')
      }
    },
    // 学校省市区选择
    provincesHandleChange (value) {
      if (!value) return
      this.provincesSchoolList = []
      this.queryForm.schoolName = ''
      this.queryForm.schoolId = ''
      this.queryForm.provinceCode = value[0]
      this.queryForm.cityCode = value[1]
      this.queryForm.areaCode = value[2]
      console.log('queryForm', this.queryForm)
      this.getSchoolListData(value)
    },
    // 获取学校List
    getSchoolListData (schoolArea) {
      console.log('schoolArea', schoolArea)
      getSchoolListWithCity({ provinceCode: schoolArea[0], cityCode: schoolArea[1], areaCode: schoolArea[2] }).then((res) => {
        console.log('getSchoolList', res)
        this.provincesSchoolList = res.data
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    // 学校选择赋值schoolId
    schoolSelectChange (schoolid) {
      this.queryForm.schoolId = schoolid
    },
    exportTable () {
      const { pageNum, pageSize, ...newForm } = this.queryForm
      const downLoadUrl = `${this.$http.defaults.baseURL}enrollment/excelQueryTbEnrollmentList?${this.$xcUtils.serialize(newForm)}`
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl)
    },
    handleToUserDetails (userId) {
      this.$router.push({
        path: '/c_data_Management/c_player_registInfo_details',
        query: { userId }
      })
    },
    showDialog (item) {
      this.editForm = {
        id: item.id,
        grade: item.grade,
        enrollmentLevel: item.enrollmentLevel,
        isOnline: item.isOnline
      }
      this.visible = true
    },
    handleCloseDialog () {
      this.visible = false
    },
    editFn () {
      updateTbEnrollmentGroup(this.editForm).then(res => {
        this.handleCloseDialog()
        this.$message.success('修改成功')
        this.getDataList()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.title_class {
  display: -moz-inline-box;
  display: inline-block;
}
</style>
